import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import translationPL from './locales/pl/translation.json';

const resources = {
  pl: {
    translation: translationPL
  }
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    backend: {
      loadPath: '/backend/api/public/translations/allTranslations/{{lng}}',
      queryStringParams: () => {
        return { t: new Date().getTime() };
      },
      requestOptions: {
        cache: 'no-store'
      }
    },
    partialBundledLanguages: true
  });

export default i18n;
